import type { Timestamp } from 'firebase/firestore';

interface Approval {
  approved: boolean;
  approvedAt: Timestamp | Date | null;
  approvedBy: string | null;
  note: string | null;
}

interface Props {
  approval: Approval | null;
}

function formatDate(at: Timestamp | Date | null): string {
  if (!at) return '';
  const d = at instanceof Date ? at : at.toDate();
  return d.toISOString().slice(0, 10);
}

export default function ApprovalBadge({ approval }: Props) {
  if (!approval) return null;
  const dateStr = formatDate(approval.approvedAt);
  if (approval.approved) {
    return (
      <span className="inline-block bg-ok text-white text-xs px-2 py-0.5 rounded">
        ✓ Godkänd {dateStr}
      </span>
    );
  }
  return (
    <div className="space-y-1">
      <span className="inline-block bg-red-100 text-red-800 text-xs px-2 py-0.5 rounded">
        ✗ Avslagen {dateStr} — behöver kompletteras
      </span>
      {approval.note && (
        <p className="text-xs text-red-800 italic">{approval.note}</p>
      )}
    </div>
  );
}
